import {Route, IndexRoute} from 'react-router';
import {FeatureFlaggedDashboard} from './FeatureFlaggedDashboard';
import DashboardContainer from 'App/containers/Dashboard/container';

export default (
  <Route component={DashboardContainer}>
    <IndexRoute component={FeatureFlaggedDashboard} />
  </Route>
);
